import React, { PureComponent } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from "@material-ui/core/DialogContent";
import { dialogActions } from '../../actions/dialog.actions';
import Button from '@material-ui/core/Button';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles'
import { styles } from "../../containers/dockPadStyle";
import { compose } from 'redux'
import DialogActions from '@material-ui/core/DialogActions';
import { connect, batch } from 'react-redux'
import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import { ThunkDispatch } from 'redux-thunk';
import { entityActions } from '../../actions/entity.actions';
import { ColumnType } from '../PhasePlan/Column';
import { TagType, SelectedTag } from '../../models/ TagType';
import { phasePlanActions } from '../../actions/phaseplan.actions';
import { lookaheadActions } from '../../actions/lookahead.actions';



export interface Props {
    isDuplicateTagDialogOpen: boolean,
    classes: ClassNameMap,
    closeDuplicateTagDialog: () => Promise<void>,
    duplicateTagValue: (tagIds: Record<string, SelectedTag>, type: ColumnType) => Promise<void>,
    dupTagIds: {},
    dupTagType: ColumnType,
    lookaheadTagsClear: () => Promise<void>,
    phasePlanTagsClear: () => Promise<void>

}

const DuplicateTagDialog: React.FunctionComponent<Props> =
    ({ isDuplicateTagDialogOpen, classes, closeDuplicateTagDialog, duplicateTagValue, dupTagIds, dupTagType, lookaheadTagsClear, phasePlanTagsClear }) => {
        const closeDialog = () => {

            return async () => {
                closeDuplicateTagDialog()
            }
        }

        const duplicateTag = () => {
            return async () => {
                if (!dupTagIds || Object.keys(dupTagIds).length <= 0) {
                    return
                }
                batch(() => {
                    duplicateTagValue(dupTagIds, dupTagType)
                    closeDuplicateTagDialog()
                    phasePlanTagsClear()
                    lookaheadTagsClear()
                })

            }
        }

        return (
            <Dialog
                open={isDuplicateTagDialogOpen}
                onBackdropClick={closeDialog()}
            >
                <React.Fragment>
                    <DialogContent>
                        <div className={classNames(classes.deleteDialog)}>
                            Are you sure you want to duplicate this tag?
                </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={closeDialog()} color="primary"> Cancel </Button>
                        <Button onClick={duplicateTag()} color="secondary"> Duplicate </Button>

                    </DialogActions>
                </React.Fragment>
            </Dialog>
        )
    }

const mapStateToProps = (state: any) => {

    const dupTagIds = state.dialogReducer.dupTagIds as Record<string, SelectedTag>
    return {
        isDuplicateTagDialogOpen: !!dupTagIds  && Object.keys(dupTagIds).length > 0,
        dupTagIds: state.dialogReducer.dupTagIds,
        dupTagType: state.dialogReducer.dupTagType
    }

};

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => {

    return {
        closeDuplicateTagDialog: () => dispatch(dialogActions.closeDuplicateTagDialog()),
        duplicateTagValue: (tagIds: Record<string, SelectedTag>, type: ColumnType) => dispatch(entityActions.duplicateTag(tagIds, type)),
        lookaheadTagsClear: () => dispatch(lookaheadActions.lookaheadSelectedTagsClearActionAsync()),
        phasePlanTagsClear: () => dispatch(phasePlanActions.phasePlanSelectedTagsClearActionAsync()),


    }
};
export default compose(
    withStyles(styles, { withTheme: true }),
    connect(mapStateToProps, mapDispatchToProps),
)(DuplicateTagDialog);



// WEBPACK FOOTER //
// ./src/components/Dialogs/DuplicateTagDialogContainer.tsx